import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  Btn,
  CustomDataTableHeader,
  CustomModal,
  CustomPanel,
  InputNumeroInteiro,
  InputText,
  Loading,
  PageHeader,
} from '../../../../components'

import { showMessageBox } from '../../../../store/actions/system.actions'
import * as CfopsHttp from '../../../../services/api/https/settings/cfop.http'

import { errorHandler } from '../../../../services/util/error.service'
import { tableCellCentered } from '../../../../assets/js/styles'

function Cfop({ dispatch, history }) {
  // Vars
  const initCfop = {
    id: null,
    codigo: '',
    natureza: '',
  }

  // Hooks
  const [isLoading, setIsLoading] = useState(false)
  const [cfops, setCfops] = useState([])
  const [state, setState] = useState(initCfop)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    getCfops()
  }, [])

  // Events
  const onBtnNovo = () => {
    setState(initCfop)
    setShowModal(true)
  }

  const onModalClose = () => {
    setShowModal(false)
  }

  const onModalSave = async cfop => {
    const index = cfops.findIndex(l => l.id === cfop.id)
    if (index !== -1) {
      const nCfops = [...cfops]
      nCfops[index] = cfop
      setCfops(nCfops)
    } else {
      setCfops([cfop, ...cfops])
    }
    setShowModal(false)
  }

  const onModalError = error => {
    dispatch(showMessageBox(null, error))
  }

  const onRowClicked = cfop => {
    setState({
      id: cfop.id,
      codigo: cfop.codigo,
      natureza: cfop.natureza,
    })
    setShowModal(true)
  }

  // Helpers
  const getCfops = async () => {
    try {
      setIsLoading(true)
      const fetchedCfops = await CfopsHttp.getCfops()

      setCfops(fetchedCfops)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <PageHeader>S.24 - Gestão de CFOPs</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onBtnNovo} onVoltar={history.goBack}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <CfopDataTable cfops={cfops} onRowClick={onRowClicked} />
          )}
        </CustomPanel>
      </div>
      <CfopModal
        isVisible={showModal}
        onError={onModalError}
        onSuccess={onModalSave}
        onClose={onModalClose}
        state={state}
        setState={setState}
      />
    </div>
  )
}

function CfopModal({ state, setState, isVisible, onClose, onSuccess, onError }) {
  // Events
  const onBtnSalvarClicked = async () => {
    try {
      const { id, codigo, natureza } = state
      if (!codigo || codigo.length !== 4) throw new Error('CFOP Incorreto')
      if (!natureza || natureza.trim() === '') throw new Error('Natureza Incorreto')

      const cfop = await CfopsHttp.saveCfop({
        id,
        codigo,
        natureza,
      })

      onSuccess(cfop)
    } catch (error) {
      onError(errorHandler(error))
    }
  }

  // Render
  return (
    <CustomModal width={800} header="Cfop" isVisible={isVisible} onClose={onClose}>
      <form className="p-grid">
        <div className="p-md-4 p-col-12">
          <InputNumeroInteiro
            label="CFOP :*"
            marginTop={10}
            value={state.codigo}
            onChange={value => setState({ ...state, codigo: value })}
            format={'####'}
          />
        </div>
        <div className="p-md-8 p-col-12">
          <InputText
            label="Natureza :*"
            marginTop={10}
            value={state.natureza}
            onChange={value => setState({ ...state, natureza: value })}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

function CfopDataTable({ cfops, onRowClick }) {
  const [globalFilter, setGlobalFilter] = useState('')

  return (
    <DataTable
      value={cfops}
      selectionMode="single"
      onSelectionChange={e => onRowClick(e.value)}
      paginator
      rows={10}
      globalFilter={globalFilter}
      header={<CustomDataTableHeader onChange={setGlobalFilter} />}
    >
      <Column field="id" header="Código" style={tableCellCentered(80)} />
      <Column field="codigo" header="CFOP" style={tableCellCentered(100)} />
      <Column field="natureza" header="Natureza da Operação" />
    </DataTable>
  )
}

export default connect()(withRouter(Cfop))
